// awk ' /^Link/ { print "\"" $3 "\"," } ' backward

const backwardZones: string[] = [
  'Africa/Asmera',
  'Africa/Timbuktu',
  'America/Argentina/ComodRivadavia',
  'America/Atka',
  'America/Buenos_Aires',
  'America/Catamarca',
  'America/Coral_Harbour',
  'America/Cordoba',
  'America/Ensenada',
  'America/Fort_Wayne',
  'America/Godthab',
  'America/Indianapolis',
  'America/Jujuy',
  'America/Knox_IN',
  'America/Louisville',
  'America/Mendoza',
  'America/Montreal',
  'America/Porto_Acre',
  'America/Rosario',
  'America/Santa_Isabel',
  'America/Shiprock',
  'America/Virgin',
  'Antarctica/South_Pole',
  'Asia/Ashkhabad',
  'Asia/Calcutta',
  'Asia/Chongqing',
  'Asia/Chungking',
  'Asia/Dacca',
  'Asia/Harbin',
  'Asia/Kashgar',
  'Asia/Katmandu',
  'Asia/Macao',
  'Asia/Rangoon',
  'Asia/Saigon',
  'Asia/Tel_Aviv',
  'Asia/Thimbu',
  'Asia/Ujung_Pandang',
  'Asia/Ulan_Bator',
  'Atlantic/Faeroe',
  'Atlantic/Jan_Mayen',
  'Australia/ACT',
  'Australia/Canberra',
  'Australia/Currie',
  'Australia/LHI',
  'Australia/NSW',
  'Australia/North',
  'Australia/Queensland',
  'Australia/South',
  'Australia/Tasmania',
  'Australia/Victoria',
  'Australia/West',
  'Australia/Yancowinna',
  'Brazil/Acre',
  'Brazil/DeNoronha',
  'Brazil/East',
  'Brazil/West',
  'Canada/Atlantic',
  'Canada/Central',
  'Canada/Eastern',
  'Canada/Mountain',
  'Canada/Newfoundland',
  'Canada/Pacific',
  'Canada/Saskatchewan',
  'Canada/Yukon',
  'Chile/Continental',
  'Chile/EasterIsland',
  'Cuba',
  'Egypt',
  'Eire',
  'Etc/UCT',
  'Europe/Belfast',
  'Europe/Tiraspol',
  'GB',
  'GB-Eire',
  'GMT+0',
  'GMT-0',
  'GMT0',
  'Greenwich',
  'Hongkong',
  'Iceland',
  'Iran',
  'Israel',
  'Jamaica',
  'Japan',
  'Kwajalein',
  'Libya',
  'Mexico/BajaNorte',
  'Mexico/BajaSur',
  'Mexico/General',
  'NZ',
  'NZ-CHAT',
  'Navajo',
  'PRC',
  'Pacific/Enderbury',
  'Pacific/Johnston',
  'Pacific/Ponape',
  'Pacific/Samoa',
  'Pacific/Truk',
  'Pacific/Yap',
  'Poland',
  'Portugal',
  'ROC',
  'ROK',
  'Singapore',
  'Turkey',
  'UCT',
  'US/Alaska',
  'US/Aleutian',
  'US/Arizona',
  'US/Central',
  'US/East-Indiana',
  'US/Eastern',
  'US/Hawaii',
  'US/Indiana-Starke',
  'US/Michigan',
  'US/Mountain',
  'US/Pacific',
  'US/Samoa',
  'UTC',
  'Universal',
  'W-SU',
  'Zulu',
];

export default backwardZones;
